<template>
	<div class="container">
		<!-- 公司简介图 -->
		<el-image v-if="about.about_img" :src="about.about_img" class="image1" fit="fill"></el-image>
		<!-- 天宏达安 -->
		<div class="title">{{$t('about.tihxd')}}</div>
		<p class="indent" v-html="about.about" v-if="$i18n.locale == 'zh'"> </p>
		<p class="indent" v-html="about.y_about" v-else-if="$i18n.locale == 'en'"> </p>
		<p class="indent" v-html="about.e_about" v-else> </p>
		<!-- 服务范围 -->
		<div class="title">{{$t('indexs.fwfc')}}</div>
		<div class="census">
			<el-image src="./static/image/head1.png" fit="cover"></el-image>
			<div class="range">
				<div class="li" v-for="(val,key) in about.service" :key='key'>
					<el-image :src="val.image" fit="contain"></el-image>
					<span v-if="$i18n.locale == 'zh'">{{val.name}}</span>
					<span v-else-if="$i18n.locale == 'en'">{{val.y_name}}</span>
					<span v-else>{{val.e_name}}</span>
				</div>
				<!-- <div class="li">
					<el-image src="./static/image/icon/dfz.png" fit="contain"></el-image>
					化学大分子
				</div>
				<div class="li">
					<el-image src="./static/image/icon/swzy.png" fit="contain"></el-image>
					生物药
				</div>
				<div class="li">
					<el-image src="./static/image/icon/zj.png" fit="contain"></el-image>
					制剂
				</div>
				<div class="li">
					<el-image src="./static/image/icon/fx.png" fit="contain"></el-image>
					分析
				</div>
				<div class="li">
					<el-image src="./static/image/icon/zcsb.png" fit="contain"></el-image>
					注册申报/药政事务
				</div>
				<div class="li">
					<el-image src="./static/image/icon/lcyj.png" fit="contain"></el-image>
					临床研究
				</div>
				<div class="li">
					<el-image src="./static/image/icon/yd.png" fit="contain"></el-image>
					药理药代毒理
				</div> -->
			</div>
		</div>
		<!-- 服务特色 -->
		<div class="title">{{$t('about.fwts')}}</div>
		<div v-for='(val,key) in about.service_trait' :key='key'>
			<div class="text" v-if="$i18n.locale == 'zh'">{{val.title}}</div>
			<div class="text" v-else-if="$i18n.locale == 'en'">{{val.y_title}}</div>
			<div class="text" v-else>{{val.e_title}}</div>
			<p v-if="$i18n.locale == 'zh'">{{val.desc}}</p>
			<p v-else-if="$i18n.locale == 'en'">{{val.y_desc}}</p>
			<p v-else>{{val.e_desc}}</p>
		</div>
		<!-- <div class="text">完善的质量体系</div>
		<p>完善的质量管理体系，以通过率100%，多次顺利通过美国FDA、中国NMPA、澳大利亚TGA、 韩国MFDS等官方机构及客户的审计。</p>
		<div class="text">充足的生产能力</div>
		<p>目前拥有超过2,800m³的总反应体积，GMP体系超过1,828.8m³。反应釜的大小从1L~20,000L之间不等，满足客户从克级到吨级的不同需求，实现项目的快速启动和及时交付。</p>
		<div class="text">周密的IP保护</div>
		<p>专注于CDMO服务，承诺不开发自己的新药产品，同时，建立了完善的客户信息保密系统，确保客户的信息受到妥善保护。</p> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
        about:{},
			}
		},
		mounted() {
      this.getabout()
		},
		methods: {
      getabout() {
				var that = this;
				this.$axios
					.post("/api/index/about", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.about = ret.data.data;
							// that.about.about = that.convert(ret.data.data.about)
							// that.about.y_about = that.convert(ret.data.data.y_about)
							// if(ret.data.data.e_about){
							// 	that.about.e_about = that.convert(ret.data.data.e_about)
							// }
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			convert (htmlText) {
				// let htmlText = '<img style="border: 0px; width: 537px; display: block;">'
				let str = htmlText.replace(/<img[^>]*>/gi, function (match, capture) {
					return match.replace(/(<img[^>]*)(\/?>)/gi, "$1width='96%' $2") // 添加width="100%"
					// return match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, 'style="width:96%;height:auto;"') // 替换style
				})
				return str
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.image1 {
			width: 900px;
			height: 500px;
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			color: #333333;
			padding: 40px 0;
		}
		.indent{
			text-indent: 2em;

			// overflow-x: auto;

		}
		p{
			font-size: 16px;
			color: #333333;
			margin-bottom: 30px;
		}
		.text{
			font-size: 18px;
			font-weight: bold;
			color: #004098;
			margin-bottom: 10px;
		}
		.census {
			width: 100%;
			height: 300px;
			position: relative;
			margin-bottom: 20px;
			.el-image {
				width: 100%;
				height: 300px;
			}
		
			.range {
				width: 100%;
				height: 300px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				
				.li {
					width: 25%;
					height: 150px;
					font-size: 16px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
				    span{
						    display: block;
							width: 60%;
							margin: 0 auto;
							text-align: center;
					}
					.el-image {
						width: 50px;
						height: 50px;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/synopsis.vue